import { render, staticRenderFns } from "./PageCollection.vue?vue&type=template&id=3e3f1454"
import script from "./PageCollection.vue?vue&type=script&lang=js"
export * from "./PageCollection.vue?vue&type=script&lang=js"
import style0 from "./PageCollection.vue?vue&type=style&index=0&id=3e3f1454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports